import React from "react";
import StripeOnboardingModal from "modals/stripe-onboarding-modal/StripeOnboardingModal";
import ColumnCounterpartyModal from "modals/column-counterparty-modal/ColumnCounterpartyModal";
import LoadingModalV1 from "modals/loading/LoadingModalV1";
import SuccessModal from "modals/success-modal/SuccessModal";
import ErrorModal from "modals/error-modal/ErrorModal";
import WarningModal from "modals/warning-modal/WarningModal";
import { OnboardingVariant } from "features/stripe/settlementRouting";
import { ColumnCounterpartyFormData } from "types/column";

// Presentational: renders the modals driven by usePaymentAccount. Spread the
// hook's return into this component: <PaymentAccountModals {...paymentAccount} />
export interface PaymentAccountModalsProps {
  onboardingUrl: string;
  onboardingVariant: OnboardingVariant;
  loadingMsg: string;
  errorMsg: string;
  successMsg: string;
  pendingReviewMsg: string;
  columnSubmitting: boolean;
  handleColumnSubmit: (formData: ColumnCounterpartyFormData) => void;
  showColumnForm: boolean;
  closeColumnForm: () => void;
  showStripeOnboarding: boolean;
  closeStripeOnboardingModal: () => void;
  showPendingReview: boolean;
  closePendingReviewModal: () => void;
  showLoading: boolean;
  showSuccess: boolean;
  closeSuccessModal: () => void;
  showError: boolean;
  closeErrorModal: () => void;
}

function PaymentAccountModals({
  onboardingUrl,
  onboardingVariant,
  loadingMsg,
  errorMsg,
  successMsg,
  pendingReviewMsg,
  columnSubmitting,
  handleColumnSubmit,
  showColumnForm,
  closeColumnForm,
  showStripeOnboarding,
  closeStripeOnboardingModal,
  showPendingReview,
  closePendingReviewModal,
  showLoading,
  showSuccess,
  closeSuccessModal,
  showError,
  closeErrorModal,
}: PaymentAccountModalsProps) {
  return (
    <>
      {showColumnForm && (
        <ColumnCounterpartyModal
          isOpen={showColumnForm}
          submitting={columnSubmitting}
          onClose={closeColumnForm}
          onSubmit={handleColumnSubmit}
        />
      )}
      {showStripeOnboarding && (
        <StripeOnboardingModal
          isOpen={showStripeOnboarding}
          onboardingUrl={onboardingUrl}
          source="settings"
          variant={onboardingVariant}
          onClose={closeStripeOnboardingModal}
        />
      )}
      {showPendingReview && (
        <WarningModal
          isOpen={showPendingReview}
          title="Verification in progress"
          message={pendingReviewMsg}
          handleClose={closePendingReviewModal}
        />
      )}
      <LoadingModalV1 isOpen={showLoading} loadingMsg={loadingMsg} />
      {showSuccess && (
        <SuccessModal
          isOpen={showSuccess}
          message={successMsg}
          handleClose={closeSuccessModal}
        />
      )}
      {showError && (
        <ErrorModal
          isOpen={showError}
          errorMsg={errorMsg}
          handleClose={closeErrorModal}
        />
      )}
    </>
  );
}

export default PaymentAccountModals;
